import { render, staticRenderFns } from "./HeaderDiscountModal.vue?vue&type=template&id=597dfc25"
import script from "./HeaderDiscountModal.vue?vue&type=script&lang=js"
export * from "./HeaderDiscountModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports